import { render, staticRenderFns } from "./Instruments.vue?vue&type=template&id=1afc7b6c"
import script from "./Instruments.vue?vue&type=script&lang=js"
export * from "./Instruments.vue?vue&type=script&lang=js"
import style0 from "./Instruments.vue?vue&type=style&index=0&id=1afc7b6c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports